module.exports = __webpack_public_path__ + "img/dashed-semicircle.0c318c02.svg";